import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 90000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('simplify_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('simplify_token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export const paperApi = {
  upload: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/papers/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  
  getAll: () => api.get('/papers'),
  
  getOne: (id) => api.get(`/papers/${id}`),
  
  analyze: (id) => api.post(`/papers/${id}/analyze`, {}, { timeout: 120000 }),
  
  delete: (id) => api.delete(`/papers/${id}`),
  
  download: async (id) => {
    const response = await api.get(`/papers/${id}/download`, {
      responseType: 'blob'
    });
    return response;
  },
  
  exportPDF: async (id) => {
    const response = await api.get(`/papers/${id}/export-pdf`, {
      responseType: 'blob'
    });
    return response;
  }
};

export const subscriptionApi = {
  cancelSubscription: () => api.post('/subscription/cancel')
};

export default api;
